import moment from 'moment-timezone';

const twoDigitNumber = value => (value >= 0 && value < 10) ? `0${value}` : `${value}`;

const monthDayHourMinuteToNow = (value, nowValue) => {
    const now = !nowValue ? moment() : moment(nowValue);
    const milliseconds = now.diff(moment(value));
    const duration = moment.duration(milliseconds);
    const minutes = twoDigitNumber(duration.minutes());
    const hours = twoDigitNumber(duration.hours());
    const days = duration.days();
    const months = Math.floor(duration.asMonths());
    let result = `${days}d ${hours}h ${minutes}m`;
    if (months > 0) {
        result = `${months}m ${result}`;
    }
    return result;
};

const hourMinuteSecondToNow = (value, nowValue) => {
    const now = !nowValue ? moment() : moment(nowValue);
    const milliseconds = now.diff(moment(value));
    if (milliseconds <= 0) {
        return '0:0';
    }
    const duration = moment.duration(milliseconds);
    const seconds = twoDigitNumber(duration.seconds());
    const minutes = twoDigitNumber(duration.minutes());
    const hours = twoDigitNumber(Math.floor(duration.asHours()));

    let result = `${minutes}:${seconds}`;
    if (hours > 0) {
        result = `${hours}:${result}`;
    }
    return result;
};

const formatTime = (value, formatType, nowValue) => {
    if (!value) {
        return '';
    }

    const momentObj = moment(value);
    switch (formatType) {
        case 'd':
            return momentObj.format('ll');
        case 'dt':
            return momentObj.format('MMM D, h:mm A');
        case 'mdhm_tn':
            return monthDayHourMinuteToNow(value, nowValue);
        case 'hms_tn':
            return hourMinuteSecondToNow(value, nowValue);
        default:
            return momentObj.format('lll');
    }
};

// millisecondsToDurationString(milliseconds) {
//     const duration = moment.duration(milliseconds);
//     const minutes = duration.minutes();
//     const hours = duration.hours();
//     const days = Math.floor(duration.asDays());
//     return `${days}d ${hours}h ${minutes}m`;
//   },



export default formatTime;


// WEBPACK FOOTER //
// ./src/utils/formatTime.js